'use client'

import { useTrustCenterConfig } from '@/contexts/TrustCenterContext'
import CertificationsOverview from './CertificationsOverview'
import ContactsOverview from './ContactsOverview'
import ControlsOverview from './ControlsOverview'
import DocumentsOverview from './DocumentsOverview'
import SubprocessorsOverview from './SubprocessorsOverview'

export default function Overview() {
  const { showControls } = useTrustCenterConfig()
  return (
    <div className="mx-auto flex w-full max-w-screen-2xl flex-col divide-y divide-trust-center-border px-4 md:px-12">
      <CertificationsOverview />
      {showControls && <ControlsOverview />}
      <div className="grid gap-10 py-8 lg:grid-cols-2">
        <DocumentsOverview />
        <SubprocessorsOverview />
      </div>
      <ContactsOverview />
    </div>
  )
}
